import { Long } from "./long";

export default Long;